import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';


// SwalComponent.prototype.confirmButtonColor = '#00a657';
// SwalComponent.prototype.cancelButtonColor = '#747474';

// const oldShow = SwalComponent.prototype.fire;

// const removeOverlay = function(successOrFailure: any) {
//   document.querySelector('.swal2-container').remove();
//   Array.prototype.forEach.call(document.querySelectorAll('.swal2-shown, .swal2-height-auto'), (element) => {
//     element.classList.remove('swal2-shown');
//     element.classList.remove('swal2-height-auto');
//   });

//   if (!window.document.activeElement) {
//     window.document.body.focus();
//   }
// };

// SwalComponent.prototype.fire = function() {
//   return oldShow.bind(this)().finally(removeOverlay);
// };

export default SwalComponent;
